import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import styled from 'styled-components';
import InProgressDot from '../ContentCards/ReducedContentCard/subcomponents/InProgressDot';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error untyped dependency
import FormattedDuration from 'I18n/components/FormattedDuration';
import { useLessonProgressTime } from '../../features/lessons';
import { FILTER_CONSTS } from '../../constants/TopFilterConstants';
import { useAssetStatus } from '../../features/userProgress/userProgressQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReadoutLessonBox = styled(UIBox).withConfig({
  displayName: "LessonCardTimeReadout__ReadoutLessonBox",
  componentId: "tntbcx-0"
})(["display:flex;&::after{content:'';margin:0 10px 0 10px;display:inline-flex;align-self:center;height:100%;}"]);
const InProgressLargeCardDot = styled(InProgressDot).withConfig({
  displayName: "LessonCardTimeReadout__InProgressLargeCardDot",
  componentId: "tntbcx-1"
})(["bottom:-9px;margin-left:3px;margin-right:9px;"]);
export const LessonCardTimeReadout = ({
  lessonId
}) => {
  const {
    remainingTime,
    totalTime
  } = useLessonProgressTime(lessonId);
  const {
    status
  } = useAssetStatus({
    id: lessonId,
    type: 'LESSON'
  });
  const showProgress = status && status !== FILTER_CONSTS.STATUSES.NOT_STARTED;
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [showProgress && /*#__PURE__*/_jsx(InProgressLargeCardDot, {}), showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(ReadoutLessonBox, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.tracks.timeRemaining.duration",
          options: {
            duration: /*#__PURE__*/_jsx(FormattedDuration, {
              from: new Date().getTime() - remainingTime * 1000
            })
          }
        })
      })
    }), !showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        from: new Date().getTime() - totalTime * 1000
      })
    })]
  });
};